export default "__VITE_ASSET__cS_FBxUC__"